"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _reactRouterDom = require("react-router-dom");

var _StringOrRender = _interopRequireDefault(require("../../helper/StringOrRender"));

var _styling = require("../../../toolkit/styling");

var _providers = require("../../../toolkit/providers");

var _class, _class2, _class3, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var DefaultPrefixedPadding = 35;

var SideMenuItem = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(SideMenuItem, _Component);

  var _super = _createSuper(SideMenuItem);

  function SideMenuItem() {
    var _this;

    (0, _classCallCheck2["default"])(this, SideMenuItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;
    return _this;
  }

  (0, _createClass2["default"])(SideMenuItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          href = _this$props.href,
          onClick = _this$props.onClick,
          selected = _this$props.selected,
          styleProps = _this$props.style,
          classNameProp = _this$props.className,
          isInternallyHandledLink = _this$props.isInternallyHandledLink,
          openLinkInNewTab = _this$props.openLinkInNewTab;
      var textBlack = this.context.theming.theme.textBlack;
      var className = (0, _styling.css)(this.styles.root, selected && this.styles.selected, classNameProp, styleProps);

      var renderInner = function renderInner() {
        if (href) {
          // Linter false positive: `noreferrer` is being applied

          /* eslint-disable react/jsx-no-target-blank */
          return /*#__PURE__*/_react["default"].createElement("a", {
            href: href,
            style: {
              color: textBlack
            },
            rel: openLinkInNewTab ? "noopener noreferrer" : undefined,
            target: openLinkInNewTab ? "_blank" : undefined
          }, /*#__PURE__*/_react["default"].createElement(_StringOrRender["default"], {
            value: title
          }));
        }

        return title;
      };

      if (isInternallyHandledLink && href) {
        return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
          to: href,
          className: className
        }, /*#__PURE__*/_react["default"].createElement(_StringOrRender["default"], {
          value: title
        }));
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: className,
        onClick: onClick
      }, renderInner());
    }
  }, {
    key: "styles",
    get: function get() {
      var prefixedPadding = this.props.prefixedPadding;
      var _this$context$theming = this.context.theming,
          _this$context$theming2 = _this$context$theming.theme,
          textBlack = _this$context$theming2.textBlack,
          hoverColor = _this$context$theming2.hoverColor,
          hoverBackground = _this$context$theming2.hoverBackground,
          fonts = _this$context$theming.fonts;
      return _aphrodite.StyleSheet.create({
        root: {
          fontSize: 16,
          lineHeight: 1.25,
          paddingTop: 15,
          paddingBottom: 15,
          paddingLeft: prefixedPadding,
          paddingRight: 15,
          cursor: "pointer",
          color: textBlack,
          fontFamily: fonts.semibold,
          ":hover": {
            color: hoverColor,
            backgroundColor: hoverBackground
          },
          userSelect: "none",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis"
        },
        selected: {
          color: hoverColor,
          backgroundColor: hoverBackground
        }
      });
    }
  }]);
  return SideMenuItem;
}(_react.Component), _class3.contextType = _providers.LegoContext, _class3.defaultProps = {
  prefixedPadding: DefaultPrefixedPadding,
  isInternallyHandledLink: false
}, _temp), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype)), _class2)) || _class;

var _default = SideMenuItem;
exports["default"] = _default;